import { useTranslation } from 'react-i18next';
import { createFromIconfontCN } from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2514747_39leu27d7eb.js',
});

export default FontIcon;